import { render } from "./user-overview.vue?vue&type=template&id=fb553ad0"
import script from "./user-overview.vue?vue&type=script&lang=js"
export * from "./user-overview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__